export const HALAL_CHECK_TAG = 'HalalCheck'

export function hasHalalCheckTag(tags = []) {
  return (tags || []).some(
    (tag) => (typeof tag === 'string' ? tag : tag?.name) === HALAL_CHECK_TAG
  )
}
